import { useCallback } from 'react'

import useSWR from 'swr'

import { menuPreferencesFetcher, updateMenuPreferences } from '@library/api-menu-experience'
import type { MenuPreferences } from '@library/api-menu-experience'

import { useAuth } from '../auth'

// this key is used to cache the menu preferences in the SWR cache and to deduplicate the requests
const swrKey = '/experience/choice/menu/v1/preferences'

export function useMenuPreferences(): {
  data?: MenuPreferences
  isLoading: boolean
  updateMenuPreferences: (newMenuPreferences: MenuPreferences) => Promise<void>
} {
  const { isAuthenticated, authUserId } = useAuth()

  const response = useSWR(
    () =>
      isAuthenticated && authUserId
        ? {
            key: swrKey,
            userId: authUserId,
          }
        : null,
    menuPreferencesFetcher,
  )

  const updateMenuPreferencesCallback = useCallback(
    async (newMenuPreferences: MenuPreferences) => {
      await response.mutate(async () => {
        await updateMenuPreferences(newMenuPreferences)

        return newMenuPreferences
      })
    },
    [response],
  )

  return {
    data: response.data,
    isLoading: !response.data && response.isValidating,
    updateMenuPreferences: updateMenuPreferencesCallback,
  }
}
